
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'

export default {
name: 'user',
props: [],
components: {
XHeader,
Group,
XButton,
XSwitch
},
data () {
return {
titlepage: this.$route.meta.title,
list: [
{
id: 0,
label: '学院',
value: true
},
{
id: 1,
label: '专业',
value: true
},
{
id: 2,
label: '班级',
value: true
},
{
id: 3,
label: 'QQ',
value: true
},
{
id: 4,
label: '微信',
value: true
},
{
id: 5,
label: '邮箱',
value: true
},
{
id: 6,
label: '联系电话',
value: true
},
{
id: 7,
label: '生源地',
value: true
},
{
id: 8,
label: '宿舍信息',
value: true
}
]
}
},
computed: {
title () {
return this.$route.meta.title
}
},
created () {},
mounted () {},
methods: {
back () {
setTimeout(() => {
this.$router.back(-1)
}, 300)
}
}
}



// WEBPACK FOOTER //
// ./src/yingxin/tskjxy/views/user/userItem/privacy.vue